import { EyeIcon, EyeOffIcon } from "@heroicons/react/solid";
import React, { useEffect, useRef, useState } from "react";
import PhoneInput from "react-phone-input-2";
import VectorIcons from "../../VectorIcons/VectorIcons";
import CurrencyInput from 'react-currency-input-field';
import { useFormat } from "../../../hooks/useFormat";
import "./styles/FInputText.css";

// Gneral Focus Hook
const UseFocus = () => {
  const htmlElRef = useRef(null)
  const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

  return [htmlElRef, setFocus]
}

const FInputText = ({
  codeCountryInit,
  type,
  title,
  errorMessage,
  placeholder,
  maxLength,
  value,
  disabled = false,
  onChange = () => { },
  iconAction = () => { },
  IconName,
  onlyCountries,
  toLowerCase = false,
  toUpperCase = false
}) => {
  switch (type) {
    case "PhoneInput":
      return (
        <FPhoneInput
          codeCountryInit={codeCountryInit}
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
          onlyCountries={onlyCountries}
        />
      );
    case "CurrencyInput":
      return (
        <CurrencyInputt
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
        /> 
      );
    case "NumberInput":
      return ( 
        <FnumberInput
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
        />
      );
    case "NumberCardInput":
      return (
        <FnumberCardInput
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
        />
      );
    case "TextIconInput":
      return (
        <FtextIconInput
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
          iconAction={iconAction}
          IconName={IconName}
        />
      );
    case "PasswordInput":
      return (
        <FPassswordInput
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
        />
      );
    default:
      return (
        <FtextInput
        toLowerCase={toLowerCase}
        toUpperCase={toUpperCase}
          errorMessage={errorMessage}
          onChange={onChange}
          maxLength={maxLength}
          placeholder={placeholder}
          title={title}
          value={value}
          disabled={disabled}
        />
      );
  }
};


const FPhoneInput = ({
  codeCountryInit,
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
  onlyCountries,
}) => {
  const { codeCountryToOnlyCountry } = useFormat();

  let [valu, setValu] = useState();

  let [countryCode, setCountryCode] = useState();
  let [phone, setPhone] = useState();
  let [phone2, setPhone2] = useState();

  useEffect(() => {
    setValu(!value ? undefined : phone);
    setCountryCode("52");
    setPhone(!value ? undefined : formatPhone(value));
    setPhone2(!value ? undefined : value.substr(-10));
  }, []);

  useEffect(() => {
    setValu(!value ? "" : phone);
    if (!value) {
      setPhone(!value ? undefined : formatPhone(value));
      setPhone2(!value ? undefined : value.substr(-10));
      setCountryCode("52");
    }
  }, [value]);

  function formatPhone(val) {
    let _val = val.substr(-10);
    var x = _val.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
    return !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
  }


  const [input1Ref, setInput1Focus] = UseFocus()

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }



  return (
    <div className="border-0 w-full pt-2">
      <div className="font-bold text-[4.5vw] xxs:text-[14px] pb-1">{title}</div>
      <PhoneInput
        disabled={disabled}
        countryCodeEditable={false}
        country={!value ? !codeCountryInit ? "mx" : codeCountryInit : codeCountryToOnlyCountry(value)}
        onlyCountries={!onlyCountries ? ["us", "mx", "co"] : onlyCountries}
        buttonClass={
          "!bg-[#e4e4e4]  !h-[52px] xxs:!h-[62px] !w-[57px] !pb-[2px] !pl-[5px] !rounded-l-[12px]"
        }
        onChange={(tel, country) => {
          setCountryCode(tel);
          let _phoneComplete = !phone2 ? "" : "+" + tel + phone2;
          if (phone2 != undefined) {
            onChange(_phoneComplete);
          }
          setInput1Focus()
        }}
        inputClass="hidden"
        // onBlur={handleFocus}
        // focused={focused.toString()}
      />
      <input
        ref={input1Ref}
        type="tel"
        disabled={disabled}
        className={`bg-backgroundInput w-full pl-16 p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${disabled ? "text-gray-400" : ""
          }`}
        placeholder={!placeholder ? "Ingresa tu teléfono" : placeholder}
        maxLength={!maxLength ? 14 : maxLength}
        value={valu}
        onChange={(e) => {
          var x = e.target.value
            .replace(/\D/g, "")
            .match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
          setPhone2(x[0]);
          let _phoneComplete = !x[0] ? "" : "+" + countryCode + x[0];
          onChange(_phoneComplete);

          // e.target.value = !x[2]
          //   ? x[1]
          //   : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "");
          setPhone(
            !x[2] ? x[1] : "(" + x[1] + ") " + x[2] + (x[3] ? "-" + x[3] : "")
          );
        }}
        onBlur={handleFocus}
        // focused={focused.toString()}
      />
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const CurrencyInputt = ({
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { }, 
}) => {
  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <CurrencyInput
        id="input-example"
        name="input-name"
        placeholder={placeholder}
        decimalsLimit={2}
        prefix="$"
        decimalSeparator="."
        groupSeparator=","
        onValueChange={onChange}
        value={value}
        disabled={disabled}
        style={{ width: "100%", background: '#f2f2f2', borderRadius: '12px', padding: '1.25rem', fontSize: '16px' }}
        onBlur={handleFocus}
      />
      {/* <input
        type="tel"
        disabled={disabled}
        className={`bg-backgroundInput w-full p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${
          disabled ? "text-gray-400" : ""
        }`}
        placeholder={placeholder}
        maxLength={!maxLength ? 9999 : maxLength}
        value={!value ? val : money(value)}
        onChange={(e) => {
          var x = e.target.value
            .replace(/\D/g, "")
            .match(/(\d{0,3})(\d{0,3})(\d{0,3})(\d{0,3})/);
          if (x[1].charAt(0) == "0") {
            x[1] = x[1].slice(1);
          }
          setVal(e.target.value);
          onChange(x[1] + x[2] + x[3] + x[4]);
        }}
      /> */}
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const FtextInput = ({
  toLowerCase,
  toUpperCase,
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
}) => {
  let [val, setVal] = useState(!value ? "" : value);

  useEffect(() => {
    setVal(!value ? "" : value);
  }, []);

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <input
        type="text"
        disabled={disabled}
        className={`bg-backgroundInput w-full p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${disabled ? "text-gray-400" : ""
          }`}
        placeholder={placeholder}
        maxLength={!maxLength ? 9999 : maxLength}
        value={val}
        onChange={(e) => {
          if (toLowerCase){
            setVal(e.target.value.toLowerCase());
            onChange(e.target.value.toLowerCase());
          } else {
            if (toUpperCase){
              setVal(e.target.value.toUpperCase());
              onChange(e.target.value.toUpperCase());
            } else {
              setVal(e.target.value);
              onChange(e.target.value);  
            }
          }
        }}
        onBlur={handleFocus}
      />
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const FnumberInput = ({
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
}) => {
  let [val, setVal] = useState(!value ? "" : value);

  useEffect(() => {
    setVal(!value ? "" : value);
  }, []);

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <input
        type={"text"}
        inputmode="numeric"
        disabled={disabled}
        className={`bg-backgroundInput w-full p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${disabled ? "text-gray-400" : ""
          }`}
        placeholder={placeholder}
        maxLength={!maxLength ? 9999 : maxLength}
        value={val}
        onChange={(e) => {
          if (e.target.value == "") {
            setVal(e.target.value);
            onChange(e.target.value);
          } else {
            let val = parseInt(e.target.value);
            if (isNaN(val)) {
            } else {
              setVal(e.target.value);
              onChange(e.target.value);
            }
          }
        }}
        onBlur={handleFocus}
      />
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const FtextIconInput = ({
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
  iconAction = () => { },
  IconName,
}) => {
  let [val, setVal] = useState(!value ? "" : value);

  useEffect(() => {
    setVal(!value ? "" : value);
  }, []);

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <div className="border-0 relative">
        {!IconName ? null : (
          <div className="border-0 absolute grid items-center justify-end pr-4 h-full w-full ">
            <VectorIcons
              name={IconName}
              cssClasses="cursor-pointer"
              onClick={iconAction}
            />
          </div>
        )}

        <input
          type="text"
          disabled={disabled}
          className={`bg-backgroundInput w-full p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${disabled ? "text-black" : ""
            }`}
          placeholder={placeholder}
          maxLength={!maxLength ? 9999 : maxLength}
          value={val}
          onChange={(e) => {
            setVal(e.target.value);
            onChange(e.target.value);
          }}
          onBlur={handleFocus}
        />
      </div>

      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const FPassswordInput = ({
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
}) => {
  let [val, setVal] = useState(!value ? "" : value);

  useEffect(() => {
    setVal(!value ? "" : value);
  }, []);

  const [passView, setPassView] = useState(true);

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <div className="flex justify-end items-center relative text-small">
        <input
          type={passView ? "password" : "text"}
          disabled={disabled}
          className={`bg-backgroundInput w-full p-5 rounded-[12px] text-[4vw] xxs:text-[16px] ${disabled ? "text-gray-400" : ""
            }`}
          placeholder={placeholder}
          maxLength={!maxLength ? 9999 : maxLength}
          value={val}
          onChange={(e) => {
            setVal(e.target.value);
            onChange(e.target.value);
          }}
          onBlur={handleFocus}
        />
        <div
          className="absolute mr-5 w-7 border-0"
          onClick={() => {
            setPassView(!passView);
          }}
        >
          <EyeIcon className={passView ? "" : "hidden"} />
          <EyeOffIcon className={!passView ? "" : "hidden"} />
        </div>
      </div>
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

const FnumberCardInput = ({
  title,
  errorMessage,
  maxLength,
  placeholder,
  value,
  disabled,
  onChange = () => { },
}) => {
  let [val, setVal] = useState(!value ? "" : value);

  useEffect(() => {
    setVal(!value ? "" : value);
  }, []);

  const [focused, setFocused] = useState(false);
  const handleFocus = () => {
    setFocused(true);
  }

  return (
    <div className="border-0 w-full pt-2">
      <div
        className={`font-bold text-[4.5vw] xxs:text-[14px] ${!title ? "pt-[24px]" : ""
          }`}
      >
        {title}
      </div>
      <div className="flex justify-end items-center relative text-small">
        <input
          type={"text"}
          inputmode="numeric"
          disabled={disabled}
          className={` w-full p-5 rounded-[12px] 
          ${val.substr(0, 1) == "4"
              ? "text-[#FFFFFF]"
              : val.substr(0, 1) == "5"
                ? "text-[#FFFFFF]"
                : val.substr(0, 1) == "3"
                  ? "text-[#FFFFFF]"
                  : "text-[#000000]"
            } 
            text-[4vw] xxs:text-[16px] ${disabled ? "text-gray-400" : ""
            }`}
          style={{
            backgroundImage: `linear-gradient(to right,${val.substr(0, 1) == "4"
                ? "#41295a,#2F0743"
                : val.substr(0, 1) == "5"
                  ? "#23074d,#cc5333"
                  : val.substr(0, 1) == "3"
                    ? "#000428,#004e92"
                    : "#F2F2F2,#F2F2F2"
              } )`,
          }}
          placeholder={placeholder}
          maxLength={!maxLength ? 9999 : maxLength}
          value={val}
          onChange={(e) => {
            if (e.target.value == "") {
              setVal(e.target.value);
              onChange(e.target.value);
            } else {
              let val = parseInt(e.target.value);
              if (isNaN(val)) {
              } else {
                setVal(e.target.value);
                onChange(e.target.value);
              }
            }
          }}
          onBlur={handleFocus}
        />
        <div className="absolute mr-5 w-14 border-0" >
          <img
            className="w-[45px] h-[45px] mr-5"
            src={
              val.substr(0, 1) == "4"
                ? require("../../assets/images/visa2.png")
                : val.substr(0, 1) == "5"
                  ? require("../../assets/images/mastercard.png")
                  : val.substr(0, 1) == "3"
                    ? require("../../assets/images/american-express.png")
                    : require("../../assets/images/other2.png")
            }
          />
        </div>
      </div>
      {
        focused && 
        <p className="text-error font-bold text-left text-small">
          {errorMessage}
        </p>
      }
    </div>
  );
};

export default FInputText;
